(function() {
  var api = window.SculptaFacelift || {};

  function rootPath() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : "/";
  }

  function formatMoney(cents, format, currencyCode) {
    cents = Number(cents) || 0;
    if (currencyCode && window.Intl && typeof window.Intl.NumberFormat === "function") {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: "currency",
          currency: currencyCode
        }).format(cents / 100);
      } catch (err) {
        // Fall through to Shopify's formatter when a browser rejects the code.
      }
    }
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents, format || window.theme && window.theme.moneyFormat || "${{amount}}");
    }
    return "$" + (cents / 100).toFixed(2);
  }

  function parseIds(value) {
    if (!value) return [];
    return String(value).split(",").map(function(id) {
      return Number(id.trim());
    }).filter(Boolean);
  }

  function openCartDrawer(cartState, fallbackUrl) {
    var drawer = document.querySelector("cart-drawer");
    if (drawer && typeof drawer.renderContents === "function" && cartState && cartState.sections) {
      if (!cartState.id && cartState.items && cartState.items[0]) cartState.id = cartState.items[0].id;
      drawer.renderContents(cartState);
      drawer.classList.remove("is-empty");
      if (typeof drawer.open === "function") drawer.open();
      return true;
    }

    return false;
  }

  function fetchCartSections() {
    return fetch(rootPath() + "?sections=cart-drawer,cart-icon-bubble", {
      headers: {
        "Accept": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      }
    }).then(function(response) {
      if (!response.ok) throw new Error("Unable to refresh cart drawer");
      return response.json();
    });
  }

  function initCountdown(scope) {
    scope.querySelectorAll("[data-sf-countdown]").forEach(function(timer) {
      if (timer.dataset.sfReady === "true") return;
      timer.dataset.sfReady = "true";
      var seconds = Number(timer.dataset.seconds) || 15120;
      var pad = function(value) { return String(value).padStart(2, "0"); };
      var render = function() {
        var h = Math.floor(seconds / 3600);
        var m = Math.floor((seconds % 3600) / 60);
        var s = seconds % 60;
        timer.textContent = pad(h) + ":" + pad(m) + ":" + pad(s);
        seconds = seconds > 0 ? seconds - 1 : Number(timer.dataset.seconds) || 15120;
      };
      render();
      window.setInterval(render, 1000);
    });
  }

  function initBeforeAfter(scope) {
    scope.querySelectorAll("[data-sf-ba]").forEach(function(compare) {
      if (compare.dataset.sfReady === "true") return;
      compare.dataset.sfReady = "true";
      var range = compare.querySelector("[data-sf-ba-range]");
      if (!range) return;
      var update = function() {
        compare.style.setProperty("--sf-ba", range.value + "%");
      };
      range.addEventListener("input", update);
      update();
    });
  }

  function initOffer(scope) {
    scope.querySelectorAll("[data-sf-offer]").forEach(function(offer) {
      if (offer.dataset.sfReady === "true") return;
      offer.dataset.sfReady = "true";

      var models = Array.prototype.slice.call(offer.querySelectorAll("[data-sf-model]"));
      var bundles = Array.prototype.slice.call(offer.querySelectorAll("[data-sf-bundle]"));
      var upsells = Array.prototype.slice.call(offer.querySelectorAll("[data-sf-upsell]"));
      var button = offer.querySelector("[data-sf-atc]");
      var error = offer.querySelector("[data-sf-error]");
      var subtotalNode = offer.querySelector("[data-sf-subtotal]");
      var savingsNode = offer.querySelector("[data-sf-savings]");
      var totalNode = offer.querySelector("[data-sf-total]");
      var includedLabelNode = offer.querySelector("[data-sf-included-label]");
      var includedListNode = offer.querySelector("[data-sf-included-list]");
      var includedGridNode = offer.querySelector("[data-included-grid]");
      var includedTitleNode = offer.querySelector("[data-included-title]");
      var stickyPriceNodes = document.querySelectorAll("[data-sf-sticky-price]");
      var stickyCompareNodes = document.querySelectorAll("[data-sf-sticky-compare]");
      var moneyFormat = offer.dataset.moneyFormat;
      var currencyCode = offer.dataset.currencyCode || "";
      var activeModel = models.find(function(card) { return card.classList.contains("is-active"); }) || models[0] || null;
      var activeBundle = bundles.find(function(card) { return card.classList.contains("is-active"); }) || bundles[0] || null;

      function getCheckedUpsells() {
        return upsells.filter(function(card) { return card.classList.contains("is-active"); });
      }

      function includedItems(card) {
        if (!card) return [];
        return [1, 2, 3, 4, 5, 6, 7, 8].map(function(index) {
          return card.getAttribute("data-included-" + index) || "";
        }).filter(Boolean);
      }

      function renderIncluded() {
        if (includedLabelNode && activeBundle) {
          includedLabelNode.textContent = activeBundle.getAttribute("data-included-label") || "";
        }
        if (includedTitleNode && activeBundle) {
          includedTitleNode.textContent = activeBundle.dataset.displayName || activeBundle.getAttribute("data-included-label") || "";
        }

        var items = includedItems(activeBundle).map(function(text) {
          var parts = String(text).split("|");
          return {
            label: (parts[0] || "").trim(),
            meta: (parts[1] || "").trim()
          };
        });

        if (includedGridNode) {
          includedGridNode.innerHTML = "";
          items.forEach(function(entry) {
            var item = document.createElement("div");
            item.className = "sc-incl-item";

            var check = document.createElement("span");
            check.className = "sc-check";
            check.setAttribute("aria-hidden", "true");
            check.innerHTML = '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';

            var textWrap = document.createElement("div");
            var label = document.createElement("div");
            label.className = "sc-incl-label";
            label.textContent = entry.label;
            textWrap.appendChild(label);

            if (entry.meta) {
              var meta = document.createElement("div");
              meta.className = "sc-incl-meta";
              meta.textContent = entry.meta;
              textWrap.appendChild(meta);
            }

            item.appendChild(check);
            item.appendChild(textWrap);
            includedGridNode.appendChild(item);
          });
        }

        if (!includedListNode) return;
        includedListNode.innerHTML = "";
        items.forEach(function(entry) {
          var item = document.createElement("li");
          item.textContent = entry.label;
          includedListNode.appendChild(item);
        });
      }

      function render() {
        var modelPrice = activeModel ? Number(activeModel.dataset.priceCents) || 0 : 0;
        var modelCompare = activeModel ? Number(activeModel.dataset.compareCents) || modelPrice : modelPrice;
        var bundlePrice = activeBundle ? Number(activeBundle.dataset.priceCents) || 0 : 0;
        var bundleCompare = activeBundle ? Number(activeBundle.dataset.compareCents) || bundlePrice : bundlePrice;
        var upsellPrice = 0;
        var upsellCompare = 0;

        getCheckedUpsells().forEach(function(card) {
          var price = Number(card.dataset.priceCents) || 0;
          upsellPrice += price;
          upsellCompare += Number(card.dataset.compareCents) || price;
        });

        var total = modelPrice + bundlePrice + upsellPrice;
        var subtotal = modelCompare + bundleCompare + upsellCompare;
        var savings = Math.max(0, subtotal - total);

        if (subtotalNode) subtotalNode.textContent = formatMoney(subtotal, moneyFormat, currencyCode);
        if (savingsNode) savingsNode.textContent = "-" + formatMoney(savings, moneyFormat, currencyCode);
        if (totalNode) totalNode.textContent = formatMoney(total, moneyFormat, currencyCode);
        stickyPriceNodes.forEach(function(node) {
          node.textContent = formatMoney(total, moneyFormat, currencyCode);
        });
        stickyCompareNodes.forEach(function(node) {
          if (!node) return;
          if (subtotal > total) {
            node.hidden = false;
            node.textContent = formatMoney(subtotal, moneyFormat, currencyCode);
          } else {
            node.hidden = true;
            node.textContent = "";
          }
        });

        if (offer) {
          offer.dataset.selected = activeBundle && activeBundle.dataset.scId ? activeBundle.dataset.scId : "";
        }

        if (button) {
          var selectedName = activeBundle && activeBundle.dataset.displayName ? activeBundle.dataset.displayName : button.dataset.label;
          var displayPrice = activeBundle && activeBundle.dataset.displayPrice ? activeBundle.dataset.displayPrice : formatMoney(total, moneyFormat, currencyCode);
          var displaySavings = activeBundle && activeBundle.dataset.displaySavings ? activeBundle.dataset.displaySavings : formatMoney(savings, moneyFormat, currencyCode);
          var ctaMain = button.querySelector("[data-sf-cta-main]");
          var ctaSub = button.querySelector("[data-sf-cta-sub]");

          if (ctaMain) {
            ctaMain.textContent = "Add " + selectedName + " — " + displayPrice;
            if (ctaSub) ctaSub.textContent = "Save " + displaySavings + " · Free shipping · 60-day returns";
          } else {
            button.textContent = button.dataset.label + " - " + formatMoney(total, moneyFormat, currencyCode);
          }
        }
        renderIncluded();
      }

      function setActive(cards, card) {
        cards.forEach(function(item) {
          item.classList.toggle("is-active", item === card);
          item.setAttribute("aria-pressed", item === card ? "true" : "false");
          if (item.hasAttribute("aria-checked")) {
            item.setAttribute("aria-checked", item === card ? "true" : "false");
          }
        });
      }

      models.forEach(function(card) {
        card.addEventListener("click", function() {
          activeModel = card;
          setActive(models, card);
          if (error) error.hidden = true;
          render();
        });
      });

      bundles.forEach(function(card) {
        card.addEventListener("click", function() {
          activeBundle = card;
          setActive(bundles, card);
          if (error) error.hidden = true;
          render();
        });
      });

      upsells.forEach(function(card) {
        card.addEventListener("click", function() {
          card.classList.toggle("is-active");
          card.setAttribute("aria-pressed", card.classList.contains("is-active") ? "true" : "false");
          if (error) error.hidden = true;
          render();
        });
      });

      function bundleItems() {
        var ids = [];
        if (activeModel) ids = ids.concat(parseIds(activeModel.dataset.variantIds));
        if (activeBundle) ids = ids.concat(parseIds(activeBundle.dataset.variantIds));
        getCheckedUpsells().forEach(function(card) {
          ids = ids.concat(parseIds(card.dataset.variantIds));
        });
        return ids.reduce(function(items, id) {
          var existing = items.find(function(item) { return item.id === id; });
          if (existing) {
            existing.quantity += 1;
          } else {
            items.push({ id: id, quantity: 1 });
          }
          return items;
        }, []);
      }

      if (button) {
        button.addEventListener("click", function() {
          var items = bundleItems();
          if (!items.length) {
            if (error) {
              error.textContent = button.dataset.error || "Select products for this section in the theme editor.";
              error.hidden = false;
            }
            return;
          }

          var label = button.textContent;
          var ctaMain = button.querySelector("[data-sf-cta-main]");
          var mainLabel = ctaMain ? ctaMain.textContent : "";
          button.disabled = true;
          if (ctaMain) {
            ctaMain.textContent = button.dataset.loading || "Adding...";
          } else {
            button.textContent = button.dataset.loading || "Adding...";
          }
          if (error) error.hidden = true;

          fetch(rootPath() + "cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json",
              "X-Requested-With": "XMLHttpRequest"
            },
            body: JSON.stringify({
              items: items,
              sections: "cart-drawer,cart-icon-bubble",
              sections_url: window.location.pathname
            })
          })
            .then(function(response) { return response.json(); })
            .then(function(response) {
              if (response && response.status) throw new Error(response.description || response.message || "Unable to add to cart");
              if (openCartDrawer(response, rootPath() + "cart")) return true;
              return fetchCartSections().then(function(sections) {
                return openCartDrawer({ sections: sections, id: Date.now() }, rootPath() + "cart");
              });
            })
            .catch(function(err) {
              if (error) {
                error.textContent = err && err.message ? err.message : button.dataset.error;
                error.hidden = false;
              }
            })
            .finally(function() {
              button.disabled = false;
              if (ctaMain) {
                ctaMain.textContent = mainLabel;
                render();
              } else {
                button.textContent = label;
              }
            });
        });
      }

      render();
    });
  }

  function initSticky(scope) {
    scope.querySelectorAll("[data-sf-sticky]").forEach(function(sticky) {
      if (sticky.dataset.sfReady === "true") return;
      sticky.dataset.sfReady = "true";
      var targetSelector = sticky.dataset.target || "#smeta-buy";
      var target = document.querySelector(targetSelector);
      var button = sticky.querySelector("[data-sf-scroll-target]");
      var mainCta = document.querySelector("#sfacelift-buy [data-sf-atc]");

      var ticking = false;

      function update() {
        var targetVisible = false;
        var ctaPassed = false;
        var showAfter = Number(sticky.style.getPropertyValue("--sf-sticky-show-after")) || 600;
        if (target) {
          var rect = target.getBoundingClientRect();
          targetVisible = rect.top < window.innerHeight && rect.bottom > 0;
        }
        if (mainCta) {
          var ctaRect = mainCta.getBoundingClientRect();
          ctaPassed = ctaRect.bottom < 0;
        } else {
          ctaPassed = window.scrollY > showAfter;
        }
        sticky.classList.toggle("is-visible", window.scrollY > showAfter && ctaPassed && !targetVisible);
      }

      function queueUpdate() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function() {
          ticking = false;
          update();
        });
      }

      if (button) {
        button.addEventListener("click", function() {
          var scrollTarget = document.querySelector(button.dataset.sfScrollTarget || targetSelector);
          if (scrollTarget) scrollTarget.scrollIntoView({ behavior: "smooth", block: "start" });
        });
      }

      update();
      window.addEventListener("scroll", queueUpdate, { passive: true });
      window.addEventListener("resize", queueUpdate);
    });
  }

  function initProductGallery(scope) {
    scope.querySelectorAll("[data-sf-product-gallery]").forEach(function(gallery) {
      if (gallery.dataset.sfGalleryReady === "true") return;
      gallery.dataset.sfGalleryReady = "true";
      var main = gallery.querySelector("[data-sf-gallery-main]");
      var mainFrame = gallery.querySelector(".sfacelift-gallery__main") || main;
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll("[data-sf-gallery-thumb]"));
      if (!main || !thumbs.length) return;
      var activeIndex = Math.max(0, thumbs.findIndex(function(thumb) {
        return thumb.classList.contains("is-active");
      }));

      function showImage(index) {
        if (!thumbs.length) return;
        activeIndex = (index + thumbs.length) % thumbs.length;
        var thumb = thumbs[activeIndex];
        var full = thumb.dataset.full;
        if (!full) return;
          thumbs.forEach(function(item) {
            item.classList.toggle("is-active", item === thumb);
            item.setAttribute("aria-current", item === thumb ? "true" : "false");
          });
          main.src = full;
          main.removeAttribute("srcset");
          if (thumb.dataset.alt) main.alt = thumb.dataset.alt;
        if (thumb.parentElement && typeof thumb.parentElement.scrollTo === "function") {
          var parent = thumb.parentElement;
          var left = thumb.offsetLeft - ((parent.clientWidth - thumb.offsetWidth) / 2);
          parent.scrollTo({ left: Math.max(0, left), behavior: "smooth" });
        }
      }

      thumbs.forEach(function(thumb, index) {
        thumb.addEventListener("click", function() {
          showImage(index);
        });
      });

      var touchStartX = 0;
      var touchStartY = 0;
      var trackingTouch = false;

      mainFrame.addEventListener("touchstart", function(event) {
        if (!event.touches || event.touches.length !== 1) return;
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
        trackingTouch = true;
      }, { passive: true });

      mainFrame.addEventListener("touchend", function(event) {
        if (!trackingTouch || !event.changedTouches || !event.changedTouches.length) return;
        var touch = event.changedTouches[0];
        var dx = touch.clientX - touchStartX;
        var dy = touch.clientY - touchStartY;
        trackingTouch = false;
        if (Math.abs(dx) < 42 || Math.abs(dx) < Math.abs(dy) * 1.25) return;
        showImage(activeIndex + (dx < 0 ? 1 : -1));
      }, { passive: true });

      mainFrame.addEventListener("keydown", function(event) {
        if (event.key === "ArrowRight") {
          event.preventDefault();
          showImage(activeIndex + 1);
        } else if (event.key === "ArrowLeft") {
          event.preventDefault();
          showImage(activeIndex - 1);
        }
      });
    });
  }

  function initReveal(scope) {
    var items = Array.prototype.slice.call(scope.querySelectorAll(".sfacelift-reveal"));
    if (!items.length) return;
    if (!("IntersectionObserver" in window)) {
      items.forEach(function(item) { item.classList.add("is-in"); });
      return;
    }
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-in");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: .1 });
    items.forEach(function(item) { io.observe(item); });
  }

  api.init = function(scope) {
    scope = scope || document;
    initCountdown(scope);
    initBeforeAfter(scope);
    initOffer(scope);
    initSticky(scope);
    initProductGallery(scope);
    initReveal(scope);
  };

  window.SculptaFacelift = api;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function() { api.init(document); });
  } else {
    api.init(document);
  }

  document.addEventListener("shopify:section:load", function(event) {
    api.init(event.target);
  });
})();